module.exports = __webpack_public_path__ + "img/landing-treatment-screen-1.4cd3e422.png";